export const nodeInputStyle = {
    rounded: "sm",
    size: "sm",
    variant: "filled",
    bg: "whiteAlpha.300",
    _hover: { bg: "whiteAlpha.400" },
};

export const nodeInputEnabledStyle = {
    rounded: "sm",
    size: "sm",
    variant: "filled",
    bg: "blue.200",
    color: "black",
    _hover: { bg: "blue.300" },
};

export const nodeDescriptionStype = {
    opacity: "0.5",
    fontSize: "0.8rem",
    fontStyle: "italic",
    mx: 1,
};
